import React, { Component, PropTypes } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { CustomIcon, CustomIconSet, HighlightText } from '@social-solutions/ssg-forms';
import { dateUtilities, formPermissionsHelpers } from '../common';
import { Iterable } from 'immutable';
import { features, featureHelpers } from '../features';
import * as icon from '../icons';

/**
 * A component that represents section of form responses.
 * Renders a title for the section and a display for earch response.
 */
export class ResponsesList extends Component {

  /**
   * Handles the view button being clicked.
   * Calls the viewResponse prop.
   * @param {*} e click event information
   * @param {*} response the response viewed
   */
  handleViewClick(e, response) {
    const {viewResponse} = this.props;
    viewResponse(response)
  }

  /**
   * Handles the edit button being clicked.
   * Calls the editResponse prop.
   * @param {*} e click event information
   * @param {*} response the response
   */
  handleEditClick(e, response) {
    const {editResponse} = this.props;
    editResponse(response)
  }

  /**
   * Sorts program information by site name first, then by program name
   * @param {*} progInfo1
   * @param {*} progInfo2
   */
  sortProgramInformation(progInfo1, progInfo2) {
    var site1 = progInfo1.siteName.toLowerCase();
    var site2 = progInfo2.siteName.toLowerCase();
    if (site1 < site2) { return -1; }
    else if (site1 > site2) { return 1; }
    else {
      var program1 = progInfo1.programName.toLowerCase();
      var program2 = progInfo2.programName.toLowerCase();
      if (program1 < program2) { return -1; }
      else if (program1 > program2) { return 1; }
      else { return 0; }
    }
  }

  /**
   * Renders a single response.
   * Contains information about the create date, form name, and site and program information.
   * @param {*} response
   * @param {string} key
   */
  renderResponse(response, key) {
    const { search, programEnrollment } = this.props;
    const createdDate = dateUtilities.getUserFriendlyFormatFromJson(response.responseCreatedDate);
    const formName = response.alias || response.formName || "";
    const formId = response.formId || '';
    const sortedPrograms = response.programs && response.programs.length > 0 ? response.programs.sort(this.sortProgramInformation) : [];
    const programInformation = sortedPrograms && sortedPrograms.length > 0 ? sortedPrograms[0] : { programName: "", siteName: "" };
    const hasMultiplePrograms = !!response.programs && response.programs.length > 1;

    const buttons = featureHelpers.featureEnabled(features.apricotPortalFormPermissionsEdit) && formPermissionsHelpers.hasEditPermission(programEnrollment, programInformation.siteId, programInformation.programId, formId) ? (
      <div>
        <button
          id='viewButton'
          className='ssg-forms-icon-btn response-view-btn'
          title="View"
          aria-label={'view response'}
          onClick={e => this.handleViewClick(e, response)}>
          <icon.eye />
        </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button
          id='editButton'
          className='ssg-forms-icon-btn response-edit-btn'
          title="Edit"
          aria-label={'edit response'}
          onClick={e => this.handleEditClick(e, response)}>
          <icon.pencil />
        </button>
      </div>
    ) : (
      <button
        id='viewButton'
        className='ssg-forms-icon-btn response-view-btn'
        title="View"
        aria-label={'view response'}
        onClick={e => this.handleViewClick(e, response)}>
        <CustomIcon iconChoice={CustomIconSet.ic_right_arrow_18x18}/>
      </button>
    );

    return (
      <div key={key} id='response' className="response ssg-forms-text normal">
        <div
          role="gridcell" // prevents issue in nvda
          id="nvda-support"
          tabIndex={0}
          className="skip"
          aria-label={createdDate + ': ' + formName}>
        </div>
        <span id='date' className="response-date">{createdDate}</span>
        <div className="response-details">
          <div id='form-name' className="response-text"><HighlightText text={formName} searchValue={search}/></div>
          <div id='program-information' className="response-sub-text">
            {programInformation.siteName ? <span id='site' className="response-site-name">{`${programInformation.siteName}`}</span> : null}
            {programInformation.siteName ? " - " : null}
            <span id='program'>{programInformation.programName}</span>
            {hasMultiplePrograms ? <FontAwesomeIcon size="lg" className="response-multi-program-icon" icon={faEllipsisH}/> : null}
          </div>
        </div>
        {buttons}
      </div>
    );
  }

  render() {
    const { responses, sectionTitle } = this.props;

    return (
      <div className="response-section">
        <div id="section-title" className="ssg-forms-text large response-section-title">{sectionTitle}</div>
        {responses && responses.map((response, index) => this.renderResponse(response, index))}
      </div>
    );
  }
}

ResponsesList.propTypes = {
  programEnrollment: PropTypes.object,
  sectionTitle: PropTypes.string,
  responses: PropTypes.instanceOf(Iterable).isRequired,
  viewResponse: PropTypes.func,
  editResponse: PropTypes.func,
  search: PropTypes.string,
}

export default ResponsesList;



// WEBPACK FOOTER //
// src/responses/responses-list.js